import React from 'react';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    classInfo: 'Class 12 – PCM',
    text: 'Triumph Classes completely changed my understanding of Physics and Math. The teachers explain concepts so clearly and the small batch size meant I could ask questions freely. I scored 94% in my boards!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Arjun Verma',
    classInfo: 'Class 10 – Science',
    text: 'I was struggling with Science until I joined Triumph Classes. The doubt sessions are incredibly helpful and the study material is excellent. My grades went from 65% to 89% in just one year.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Sneha Patel',
    classInfo: 'Class 8 – Mathematics',
    text: "The teaching approach here is unlike any other coaching I've attended. Teachers are patient, approachable, and genuinely care about student progress. My daughter loves going to class now!",
    rating: 5,
  },
  {
    id: 4,
    name: 'Rohit Gupta',
    classInfo: 'Class 12 – Chemistry',
    text: 'Chemistry was my weakest subject. The way Triumph Classes taught Organic Chemistry with real-life examples made it so interesting. Cleared JEE Mains with a great percentile. Highly recommend!',
    rating: 5,
  },
];

function Stars({ count }) {
  return (
    <div className="testimonial-card__stars">
      {Array.from({ length: count }).map((_, i) => (
        <span key={i}>⭐</span>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <div className="testimonials">
      <div className="testimonials__container">
        <h2 className="section-title">What Our Students Say</h2>
        <div className="section-divider"></div>
        <p className="section-subtitle">
          Real stories from students who transformed their academic journey with Triumph Classes
        </p>
        <div className="testimonials__grid">
          {testimonials.map((t) => (
            <div key={t.id} className="testimonial-card">
              <div className="testimonial-card__quote">"</div>
              <Stars count={t.rating} />
              <p className="testimonial-card__text">{t.text}</p>
              <div className="testimonial-card__author">
                <div className="testimonial-card__avatar">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="testimonial-card__name">{t.name}</div>
                  <div className="testimonial-card__class">{t.classInfo}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
